import { render } from "./Navigation.vue?vue&type=template&id=5448a8cd"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"
script.render = render

export default script